





























import Vue from "vue";

export default Vue.extend({
  name: "app-layout",
  props: {
    showNav: {
      type: Boolean,
      default: false
    },
    showSearch: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      authenticated: false,
      scrollingDown: false
    }
  },
  mounted() {
    var subdomain = window.location.hostname.split('.')[0];
    if (subdomain !== null && subdomain != '') {
      const el = document.body;
      subdomain = subdomain.replace("tls-", "");
      subdomain = subdomain.replace("gabrielcam-public-dev", "amazon");      
      el.classList.add(subdomain);
    }
    this.$auth.onAuthStateChanged(user => {
      this.authenticated = !!user
    })
  }
});
